import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import './App.css';
// import './all_styles.scss';
import './index.scss';
import './globals.scss';
import { initToolbar } from '@stagewise/toolbar';

// Auth
import { AuthProvider, ProtectedRoute } from './login';

// Pages
import Home from './pages/Home';
import About from './pages/About';
import LoginPage from './login/LoginPage';
import Dashboard from './pages/Dashboard';
import AzureCallback from './pages/AzureCallback';
import AzureOAuth2Callback from './pages/AzureOAuth2Callback';
import CitationReader from './pages/CitationReader';
import Citations from './pages/Citations';

// Components
import Header from './components/Header';
import Footer from './components/Footer'; 

const stagewiseConfig = {
  plugins: [],
};

// Layout wrapper component to handle different layouts
function AppContent() {
  const [selectedPage, setSelectedPage] = useState('');
  const location = useLocation();

  // Check if current route is a chat page
  const isChatPage = false;

  // Check if we're on home with Query engine selected
  const isQueryEngineSelected = location.pathname === '/' && selectedPage === 'Query engine';

  return (
    <div className="min-h-screen flex flex-col bg-brand-light">
      {!isChatPage && <Header selectedPage={selectedPage} onPageSelect={setSelectedPage} />}

      {isChatPage ? (
        // Full height layout for chat pages
        <main className="flex-1 overflow-hidden">
          <Routes>
              <Route path="/login" element={<LoginPage />} />
              <Route path="/auth/azure/callback" element={<AzureCallback />} />
              <Route path="/auth/azure/oauth2callback" element={<AzureOAuth2Callback />} />
              <Route path="/oauth2callback" element={<AzureOAuth2Callback />} />
              <Route 
                path="/" 
                element={
                  <ProtectedRoute>
                    <Home selectedPage={selectedPage} onPageSelect={setSelectedPage} />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/dashboard" 
                element={
                  <ProtectedRoute>
                    <Dashboard />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/about" 
                element={
                  <ProtectedRoute>
                    <About />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/citations" 
                element={
                  <ProtectedRoute>
                    <Citations />
                  </ProtectedRoute>
                } 
              />
              <Route
                path="/citation/:citation_uuid/read"
                element={
                  <ProtectedRoute>
                    <CitationReader />
                  </ProtectedRoute>
                }
              />
          </Routes>
        </main>
      ) : (
        // Regular layout for other pages
        <>
          <main className="flex-1 container mx-auto px-4 py-8">
            <Routes>
              <Route path="/login" element={<LoginPage />} />
              <Route path="/auth/azure/callback" element={<AzureCallback />} />
              <Route path="/auth/azure/oauth2callback" element={<AzureOAuth2Callback />} />
              <Route path="/oauth2callback" element={<AzureOAuth2Callback />} />
              <Route
                path="/"
                element={
                  <ProtectedRoute>
                    <Home selectedPage={selectedPage} onPageSelect={setSelectedPage} />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/dashboard"
                element={
                  <ProtectedRoute>
                    <Dashboard />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/about"
                element={
                  <ProtectedRoute>
                    <About />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/citations"
                element={
                  <ProtectedRoute>
                    <Citations />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/citation/:citation_uuid/read"
                element={
                  <ProtectedRoute>
                    <CitationReader />
                  </ProtectedRoute>
                }
              />
            </Routes>
          </main>
          <Footer />
        </>
      )}
    </div>
  );
}

function App() {
  return (
    <Router>
      <AuthProvider>
        <AppContent />
      </AuthProvider>
    </Router>
  );
}

export default App;
